import { isValidEmail } from 'data/string';
import { ORGANIZATION_AGENTS_ADD, } from '../TenantSegmentEvents';
import './agentModal.scss';
export class AgentModalController {
    static $inject = ['close', 'TenantService', 'ContextProcessorService', 'LoadingService', '$translate', 'SegmentService', 'BlipToastService'];
    constructor(close, TenantService, ContextProcessorService, LoadingService, $translate, SegmentService, BlipToastService) {
        'ngInject';
        this.close = close;
        this.TenantService = TenantService;
        this.ContextProcessorService = ContextProcessorService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.emails = [];
        this.validForm = false;
        this.emailListHasExistentUser = false;
        this.onChangeEmails = event => {
            const { value, data } = event.detail;
            if (value && !Array.isArray(value)) {
                if (isValidEmail(value.trim())) {
                    this.emails = data;
                    return;
                }
            }
            else {
                if (!this.inputEmailElement.value) {
                    this.emails = [];
                }
            }
        };
        this.onBlurEmails = async () => {
            await this.convertValueToChip();
            const isValidInput = await this.inputEmailElement.isValid();
            this.setInputValidity(isValidInput);
            await this.checkExistentUserInEmailList();
        };
        this.setInputValidity = (value) => {
            this.inputEmailElement.danger = !value;
            this.validForm = value;
        };
        this.$onInit();
    }
    async $onInit() {
        this.invalidEmailError = await this.$translate('agentModal.invalidEmail');
        this.tenantId = this.ContextProcessorService.tenant.id;
        this.isLoading = false;
        this.pages = {
            intitation: true,
            success: false,
        };
        this.plan = await this.TenantService.getTenantPlan(this.tenantId);
    }
    get inputEmailElement() {
        return document.querySelector('#agent-emails');
    }
    async checkExistentUserInEmailList() {
        const tenantUsersResource = await this.TenantService.getTenantUsers(this.ContextProcessorService.tenant.id);
        const currentTenantEmails = tenantUsersResource.items.map(tu => tu.fullName);
        this.emailListHasExistentUser = currentTenantEmails.some(tenantEmail => this.emails.some(email => tenantEmail === email));
    }
    async addAgents() {
        if (this.isLoading == true) {
            return;
        }
        this.pages.intitation = false;
        this.isLoading = true;
        const currentTenant = this.ContextProcessorService.tenant;
        try {
            const emails = [...new Set(this.emails)];
            await this.TenantService.saveAgents(emails, currentTenant.id);
            this.isLoading = false;
            this.pages.success = true;
            this.SegmentService.createOrganizationTrack(ORGANIZATION_AGENTS_ADD, {
                plan: this.plan,
                agents: this.emails,
                buttonClick: 'confirm',
                status: 'success',
            });
        }
        catch (e) {
            this.close();
            console.error(e);
            const msg = await this.$translate('agentModal.addError');
            this.BlipToastService.show('danger', {
                msg,
            });
        }
    }
    closeModal() {
        if (!this.pages.success) {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_AGENTS_ADD, {
                buttonClick: 'cancel',
                status: 'success',
                plan: this.plan,
            });
            return this.close(false);
        }
        return this.close(true);
    }
    async convertValueToChip() {
        if (!this.inputEmailElement.value) {
            return;
        }
        await this.inputEmailElement.add(this.inputEmailElement.value);
        this.inputEmailElement.value = '';
    }
}
AgentModalController.$inject = ['close', 'TenantService', 'ContextProcessorService', 'LoadingService', '$translate', 'SegmentService', 'BlipToastService'];
